export default __webpack_public_path__ + "8f3139189e4ff95c9c127d6eefeb0301.ttf";